export default "__VITE_ASSET__DFq1uvtS__"